import { OpenFolderIcon, SidebarFacilityIcon } from "~/icons/icons";

export const CONTACT_CREATED_DATE = "CONTACT_CREATED_DATE";
export const CONTACT_COMPANY = "CONTACT_COMPANY";

export const ContactCreatedDateFilterObj = {
  id: CONTACT_CREATED_DATE,
  name: "Created Date",
  icon: OpenFolderIcon,
};

/** Company dropdown — FacilityName with `showNotAssigned` for unassigned contacts. */
export const ContactCompanyFilterObj = {
  id: CONTACT_COMPANY,
  name: "Company",
  icon: SidebarFacilityIcon,
  showNotAssigned: true,
};

export const contactsDefaultFilters = [
  ContactCreatedDateFilterObj,
  ContactCompanyFilterObj,
];
